import { useSelector } from "react-redux";
import { countriesSelector, currentCountrySelector } from "@selectors/countries.selector";
import { useMemo } from "react";

export function useCountries () {
    return useSelector(countriesSelector) as Array<{
        /* partial of the reference from the countries.reducer.js:50*/
        name: string;
        countryCode: string;
        currencyCharComponent: string;
    }>;
}
export function useCurrentCountryCode () {
    return useSelector(currentCountrySelector) as string;
}

export function useCurrentCurrency () {
    const countries = useCountries();
    const currentCountryCode = useCurrentCountryCode();

    const currentCountry = useMemo(
        () => countries.find(c => c.countryCode === currentCountryCode),
        [countries, currentCountryCode]
    );

    return currentCountry?.currencyCharComponent ?? '';
}